import { render, staticRenderFns } from "./DynamicBudgets.vue?vue&type=template&id=635064f6&"
import script from "./DynamicBudgets.vue?vue&type=script&lang=js&"
export * from "./DynamicBudgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports